import { markAsCompleted } from './_core'

/**
 * 
 * @param	{Object}	input	
 * @param	{String}	input.cssSelector
 * @param	{Function}	next	
 * @param	{Object}	context	
 * 
 * @return	{Void}
 */
export default function track(input, next, context) {
	try {
		const { debug } = context || {}
		const { id, cssSelector } = input||{}
		if (debug)
			console.log(`INFO - Start tracking 'click' event (id: ${id}, cssSelector: ${cssSelector})`)
		if (!cssSelector || typeof(cssSelector) != 'string') {
			if (debug)
				console.log(`WARN - CSS selector not defined for 'click' event (id: ${id}, cssSelector: ${cssSelector})`)
			markAsCompleted(id, next, context)
			return 
		}

		const result = observe(id, cssSelector, debug, next, context)
		if (!result) {
			// Retry on 3 seconds. Maybe the page is slow and the DOM has not loaded yet.
			if (debug)
				console.error(`ERROR - DOM element for CSS selector ${cssSelector} not found. Trying again in 3 seconds...`)

			setTimeout(() => {
				const result = observe(id, cssSelector, debug, next, context)
				if (!result) {
					if (debug)
						console.error(`ERROR - No luck. The DOM element for CSS selector ${cssSelector} is still not found. Programming another check when the page reloads or changes.`)

					const apply = (target, thisArg, args) => {
						setTimeout(() => {
							observe(id, cssSelector, debug, next, context)
						}, 2000)
						
						return target.apply(thisArg, args)
					}
					window.history.pushState = new Proxy(window.history.pushState, { apply })
					window.history.replaceState = new Proxy(window.history.replaceState, { apply })
				}
			}, 3000)

		}
	} catch(err) {
		console.error(`ERROR - Failed to track 'click' instruction. Details: ${err.stack||err.message}`)
	}
}

const observe = (id, cssSelector, debug, next, context) => {
	try {
		const els = document.querySelectorAll(cssSelector)
		const el = els[0]
		if (els.length > 1 && debug)
			console.log(`WARN - Found more than one DOM element matching CSS selector ${cssSelector}. Using the first one and ignoring the others for 'click' event id: ${id}.`)
		if (el) {
			if (debug)
				console.log(`INFO - Start listening on 'click' event on element <${el.tagName}> (CSS selector ${cssSelector})`)

			el.addEventListener('click', () => {
				markAsCompleted(id, next, context)
			})
			
			if (debug)
				console.log(`INFO - Successfully listening on 'click' event on element <${el.tagName}> (CSS selector ${cssSelector})`)
			return true
		} else 
			return false
	} catch(err) {
		console.error(`ERROR - Failed to listen on 'click' event for CSS selector ${cssSelector}. Details: ${err.stack||err.message}`)
		throw err
	}
}